<template>
  <AppDialogContent
    v-model="dialog"
    :form-error="formError"
    :persistent="formSubmitted"
    :loading="formSubmitted"
    :disabled-submit="!newRegistrantPersonId || !isNotSameRegistrantPerson"
    @submit-form="handleSubmit"
  >
    <template #header>
      {{
        $t(
          "people:ShoppingBasket.ChangeRegistrationResponsible.modal.heading",
          "Change responsible payer for registration"
        )
      }}
    </template>
    <div v-if="dialog">
      <p style="font-size: 18px">
        {{
          $t(
            "people:ShoppingBasket.ChangeRegistrationResponsible.modal.currentResponsible.label",
            "Current responsible payer:"
          )
        }}
        {{ registration.registrantPerson.name }}
      </p>

      <div class="mb-4">
        <span style="font-size: 16px"
          >{{
            $t(
              "people:ShoppingBasket.ChangeRegistrationResponsible.modal.selectNewResponsible.subheading",
              "Select new responsible payer"
            )
          }}
        </span>
      </div>
      <AppSelectPerson
        v-model="newRegistrantPersonId"
        :label="
          $t(
            'people:ShoppingBasket.ChangeRegistrationResponsible.modal.newResponsible.label',
            'New responsible'
          )
        "
        :hint="
          $t(
            'people:ShoppingBasket.ChangeRegistrationResponsible.modal.newResponsible.hint',
            'Start typing person´s name or ID to find new responsible payer'
          )
        "
        persistent-hint
        show-details
        class="mb-2"
      />
      <p>
        {{
          $t(
            "people:ShoppingBasket.ChangeRegistrationResponsible.modal.explanatoryText.text",
            "You are going to change payer for registration. All competitions and products will be moved to the new payer´s shopping basket. Check if the new payer is correctly selected and press Confirm button. "
          )
        }}
      </p>
    </div>
  </AppDialogContent>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";

import AppDialogContent from "@elements/AppDialogContent.vue";
import AppSelectPerson from "@AppSelects/AppSelectPerson.vue";

export default defineComponent({
  name: "ChangePayerDialog",
  components: { AppSelectPerson, AppDialogContent },
  inject: {
    refetchBasket: {
      default: () => true
    }
  },
  data() {
    return {
      registration: null,
      dialog: false,
      newRegistrantPersonId: null,
      formSubmitted: false,
      formError: {}
    };
  },
  computed: {
    isNotSameRegistrantPerson() {
      return (
        (this.registration?.registrantPerson?.id ?? null) !=
        this.newRegistrantPersonId
      );
    }
  },
  methods: {
    openForm(registration) {
      this.registration = registration;
      this.newRegistrantPersonId = null;
      this.dialog = true;
    },
    async handleSubmit() {
      this.formSubmitted = true;

      try {
        await this.$apollo.mutate({
          mutation: gql`
            mutation registrationChangeRegistrantPerson(
              $id: ID!
              $newRegistrantPersonId: ID!
            ) {
              registrationChangeRegistrantPerson(
                input: {
                  id: $id
                  newRegistrantPersonId: $newRegistrantPersonId
                }
              ) {
                registration {
                  id
                  registrantPersonId
                  registrantPerson {
                    id
                    name
                  }
                  allowedMutations
                }
              }
            }
          `,
          variables: {
            id: this.registration.id,
            newRegistrantPersonId: this.newRegistrantPersonId
          }
        });

        this.$root.$snackbar("success");
        this.dialog = false;
        // some reason inject default fails
        if (typeof this.refetchBasket === "function") this.refetchBasket();
      } catch (error) {
        this.formError = { type: "graphql", err: error };
        this.$root.$snackbarServerError(error, { level: "error" });
      } finally {
        this.formSubmitted = false;
      }
    }
  },
  fragments: {
    registrationFields: gql`
      fragment _ on Registration {
        id
        registrantPerson {
          id
          name
        }
        allowedMutations
      }
    `
  }
});
</script>
